import { getCdnImageUrl } from '@/utils/network'
import logger from '@/utils/logger'

/**
 * Creates a URL to an image in our Image CDN repository
 * and wraps in the 'url()' wrapper for css
 *
 * @param {string} path
 * @returns {string} Example: 'path(https://cdn.domain/path/to/image.ext)'
 */
export function getCdnImgUrlForCss(path) {
  return `url('${getCdnImageUrl(path)}')`
}

/**
 * Converts the given PX value to a REM equivalent.
 *
 * @param {number} value
 * @returns {number}
 */
export function pxToRem(value) {
  return value / 16
}

/**
 * Converts the given REM value to a PX equivalent.
 *
 * @param {number} value
 * @returns {number}
 */
export function remToPx(value) {
  return value * 16
}

/**
 * Detects the CSS size unit in the given value and returns the PX equivalent of the value.
 *
 * @param {string} valueWithUnit Eg. `30px` or `40.3rem`
 * @returns {number}
 */
export function cssSizeToPx(valueWithUnit) {
  const cleanedValue = valueWithUnit.trim()
  const [unit] = cleanedValue.match(/[^.\d]+$/) || []
  const [value] = cleanedValue.match(/^[\d.]+/) || []
  const parsedValue = parseFloat(value)

  switch (unit) {
    case 'px':
      return parsedValue
    case 'rem':
      return remToPx(parsedValue)
    default:
      logger.warn(`CSS unit ${unit} isn't support by cssSizeToPx`)
      return 0
  }
}
